// src/main.tsx
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import ShotPlanner from "./components/ShotPlanner";
import './index.css'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Main planner route */}
        <Route path="/plan" element={<ShotPlanner />} />

        {/* Root path redirects to /plan */}
        <Route path="/" element={<Navigate to="/plan" replace />} />

        {/* Catch-all → planner */}
        <Route path="*" element={<Navigate to="/plan" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
)
